<template>
  <div id="notification" :class="`alert alert-${type} alert-dismissable alert-style-1`">
    <button @click="close" type="button" class="close">×</button>
    <i :class="`zmdi zmdi-${iconClass}`"></i>
    {{text}}
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: {
    type: {
      type: String,
      default: "info"
    },
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$eventBus.hideNotification();
    }
  },
  computed: {
    iconClass() {
      switch (this.type) {
        case "success":
          return "check";
        case "info":
          return "info-outline";
        case "warning":
          return "alert-circle-o";
        default:
          return "block";
      }
    }
  }
};
</script>

<style lang="scss">
#notification {
  position: fixed;
  top: 1%;
  width: 98%;
  left: 1%;
  z-index: 10000;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/notifications/Notification.vue